export default {
      id: "icon--sww-check-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--sww-check-usage",
      toString: function () {
        return this.url;
      }
    }